import { isEmpty } from 'lodash';
import React, { ReactElement } from 'react';
import { handleScrollToSection } from '../../../utils/reportingUtility';
import RefreshInfoCard from '../reportingUtils/RefreshInfoCard';
import { REPORTING_CONSTANTS } from '../reportingUtils/reportingAndAnalyticsConstants';
import TransactionReportModal from '../reportingUtils/TransactionReportModals';
import { ReactComponent as ReportingNavigationRightIcon } from '../../../assets/images/svg/ReportingNavigationRightIcon.svg';
import { ReactComponent as ReportingNavigationDownIcon } from '../../../assets/images/svg/ReportingNavigationDownIcon.svg';
import { ReactComponent as ReportingNavigationRightIconGrey } from '../../../assets/images/svg/ReportingNavigationRightIconGrey.svg';
import { ReactComponent as ReportingNavigationDownIconGrey } from '../../../assets/images/svg/ReportingNavigationDownIconGrey.svg';
import { MetricNavSidebarProps } from '../../../shared/interfaces/reportingAndAnalyticsInterface';

const TatReportNavigation: React.FC<MetricNavSidebarProps> = ({
  sections,
  activeSection,
  configuredPayers,
  availableStatus,
  refreshedInfo,
  expandedSections,
  setExpandedSections,
}: MetricNavSidebarProps): ReactElement => {
  const toggleSection = (key: string): void => {
    setExpandedSections((prev: Record<string, boolean>): Record<string, boolean> => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="metric-nav-sidebar">
      <TransactionReportModal
        configuredPayers={configuredPayers}
        availableStatus={availableStatus}
        refreshedInfo={refreshedInfo}
      />

      {!isEmpty(refreshedInfo) && (
        <div className="nav-sections">
          {sections?.map(({ key, label, subgroups = [] }: any): ReactElement => {
            const isSectionActive =
              activeSection === key ||
              subgroups?.some((subGroup: any): boolean => subGroup?.key === activeSection);

            const isExpanded = !!expandedSections[key];

            return (
              <div key={key} className="nav-section">
                <div
                  className={`nav-item section-item ${isSectionActive ? 'active' : ''
                    }`}
                  onClick={(): void => {
                    toggleSection(key);
                    handleScrollToSection(key);
                  }}
                >
                  {!isEmpty(subgroups) && (
                    <span className="arrow-icon">
                      {isExpanded ? (
                        isSectionActive ? (
                          <ReportingNavigationDownIcon />
                        ) : (
                          <ReportingNavigationDownIconGrey />
                        )
                      ) : isSectionActive ? (
                        <ReportingNavigationRightIcon />
                      ) : (
                        <ReportingNavigationRightIconGrey />
                      )}
                    </span>
                  )}
                  <span className="subgroup-item">{label}</span>
                </div>

                {isExpanded && !isEmpty(subgroups) && (
                  <div className="nav-subgroups">
                    {subgroups?.map((subGroup: any): ReactElement => (
                      <div
                        key={subGroup.key}
                        className={`nav-item-subgroup-item ${activeSection === subGroup?.key ? 'active' : ''
                          }`}
                        onClick={(): void => handleScrollToSection(subGroup?.key)}
                      >
                        {subGroup?.label ?? ''}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      <RefreshInfoCard
        dataAvailableFrom={refreshedInfo?.dataAvailableFrom}
        lastRefreshedOn={refreshedInfo?.lastRefreshedOn}
        refreshFrequency={
          refreshedInfo?.dataRefreshedOn ?? REPORTING_CONSTANTS.EVERY_15_MINUTES
        }
      />
    </div>
  );
};

export default TatReportNavigation;
